module.exports = __webpack_public_path__ + "fonts/BebasNeueLight.eb45c171.ttf";